import { apiGet, apiPost } from '../ApiClient';

/**
 * Check the current session by calling Frappe's get_logged_user.
 * Returns { user: 'user@example.com' } if authenticated.
 * Throws on network error or if not logged in.
 */
export async function checkSession() {
  const res = await apiGet('method/frappe.auth.get_logged_user');
  // Frappe returns { message: "user@example.com" }
  const user = res?.message;
  if (!user || user === 'Guest') {
    throw new Error('Not authenticated');
  }
  return { user };
}

/**
 * Log out the current user.
 * Full page reload to clear all React state + query cache.
 */
export async function logout() {
  await apiPost('method/logout');
  window.location.href = '/auth-login';
}
